import React, { useState } from 'react';
import type { Ctx, Notice } from '../ctx';
import { Icon, type IconName } from '../icons';
import { fmtDate, fmtTime, localDay, todayKey } from '../format';
import { Empty, Panel, Pill, Row, Section } from '../ui';

const KIND_ICON: Record<Notice['kind'], IconName> = { start: 'play', stop: 'stop', note: 'note', info: 'bell' };
const KIND_TONE: Record<Notice['kind'], 'good' | 'warn' | 'info' | undefined> = { start: 'good', stop: 'warn', note: 'info', info: undefined };

function NoticeRow({ n }: { n: Notice }) {
  return (
    <Row>
      <Pill icon={KIND_ICON[n.kind]} tone={KIND_TONE[n.kind]}>
        {fmtTime(n.at)}
      </Pill>
      <div className="grow">
        <div className="title">{n.title}</div>
        <div className="sub" style={{ whiteSpace: 'normal' }}>
          {n.body}
        </div>
      </div>
      <span className="muted tiny">{fmtDate(n.at)}</span>
    </Row>
  );
}

/** Registro delle notifiche ricevute (sessioni avviate/terminate, note). */
export function NoticesPage({ ctx }: { ctx: Ctx }) {
  const today = todayKey();
  const todays = ctx.notices.filter((n) => localDay(n.at) === today);
  const older = ctx.notices.filter((n) => localDay(n.at) !== today);
  const [openToday, setOpenToday] = useState(true);
  const [openOlder, setOpenOlder] = useState(true);

  return (
    <div className="panels single">
      <Panel
        title="Notifiche"
        subtitle="Quello che è successo mentre l'app era aperta"
        right={
          ctx.notices.length > 0 ? (
            <button type="button" className="btn small ghost" title="Toglie tutte le notifiche da questa lista" onClick={ctx.clearNotices}>
              <Icon name="trash" size={15} /> Svuota
            </button>
          ) : undefined
        }
      >
        {ctx.notices.length === 0 ? (
          <Empty icon="bell">Nessuna notifica per ora.</Empty>
        ) : (
          <>
            <Section title="Oggi" count={todays.length} open={openToday} onToggle={() => setOpenToday((o) => !o)}>
              {todays.length === 0 ? <div className="muted small">Niente oggi.</div> : todays.map((n) => <NoticeRow key={n.id} n={n} />)}
            </Section>
            <Section title="Precedenti" count={older.length} open={openOlder} onToggle={() => setOpenOlder((o) => !o)}>
              {older.length === 0 ? <div className="muted small">Nessuna notifica precedente.</div> : older.map((n) => <NoticeRow key={n.id} n={n} />)}
            </Section>
          </>
        )}
      </Panel>
    </div>
  );
}
